import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorOption from './../ConfiguratorOption'
import Dropdown from './../Dropdown'
import X46MK2TransomConfiguratorImage from './X46MK2TransomConfiguratorImage'
import { exteriorView01ImageOptions } from './views/ExteriorView01'

const EXTERIOR_OPTION_FIELDS = [
  {
    key: 'HullColorways',
    optionsProp: 'hullColourOptions',
    label: 'Hull colorways'
  },
  {
    key: 'Bowsprit',
    optionsProp: 'bowSpritOptions',
    label: 'Bowsprit'
  },
  {
    key: 'HullTreatment',
    optionsProp: 'hullTreatmentOptions',
    label: 'Hull treatment'
  },
  { key: 'TeakDeck', optionsProp: 'teakDeckOptions', label: 'Teak deck' },
  {
    key: 'TeakOnSideDecks',
    optionsProp: 'teakOnSideDecksOptions',
    label: 'Teak on side decks'
  },
  {
    key: 'BathingPlatform',
    optionsProp: 'bathingPlatformOptions',
    label: 'Bathing platform'
  },
  { key: 'SelfTacker', optionsProp: 'selfTackerOptions', label: 'Self tacker' },
  {
    key: 'TeakOnCoachRoof',
    optionsProp: 'teakOnCoachRoofOptions',
    label: 'Teak on coach roof'
  },
  { key: 'Wheel', optionsProp: 'wheelOptions', label: 'Wheel' },
  {
    key: 'MastAndBoom',
    optionsProp: 'mastAndBoomOptions',
    label: 'Mast and boom'
  },
  { key: 'BoomCover', optionsProp: 'boomCoverOptions', label: 'Boom cover' },
  {
    key: 'OutboardBracket',
    optionsProp: 'outboardBracketOptions',
    label: 'Outboard bracket'
  },
  {
    key: 'CockpitBenchExtentions',
    optionsProp: 'cockpitBenchExtentionsOptions',
    label: 'Cockpit bench extensions'
  },
  {
    key: 'CockpitCushionBackrests',
    optionsProp: 'cockpitCushionBackrestsOptions',
    label: 'Cockpit cushion backrests'
  },
  {
    key: 'CockpitCushionSeats',
    optionsProp: 'cockpitCushionSeatsOptions',
    label: 'Cockpit cushion seats'
  },
  {
    key: 'CockpitFabric',
    optionsProp: 'cockpitFabricOptions',
    label: 'Cockpit fabric'
  },
  {
    key: 'SprayhoodFabric',
    optionsProp: 'sprayhoodOptions',
    label: 'Sprayhood fabric'
  },
  { key: 'GTSeat', optionsProp: 'gtSeatOptions', label: 'GT seat' },
  { key: 'Flag', optionsProp: 'flagOptions', label: 'Flag' }
]

const ON_OFF_OPTIONS = [
  { value: 1, label: 'Off' },
  { value: 2, label: 'On' }
]

class X46MK2AllExteriorOptions extends Component {
  constructor (props) {
    super(props)
    this.handleOptionChange = this.handleOptionChange.bind(this)
  }

  handleOptionChange (key, newValue) {
    const configuration = this.props.configuration
    configuration[key] = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = exteriorView01ImageOptions

    const image = (
      <X46MK2TransomConfiguratorImage
        colorMultiplier={0.75}
        name={this.props.transom.Name}
        port={this.props.transom.Port}
        transomSize={{ width: 2895, height: 780 }}
        transform={[
          0.062357, -0.000963, 0, -2.3e-5, 0.003397, 0.097934, 0, 5.6e-6, 0, 0,
          1, 0, 220.028066, 404.093037, 0, 1
        ]}
        boat='X46MK2'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>All exterior options</h1>
          <p style={{ fontSize: 14, color: '#666' }}>
            Hidden dev view — not linked from the configurator steps.
          </p>
          {EXTERIOR_OPTION_FIELDS.map(({ key, optionsProp, label }) => {
            let options =
              this.props[optionsProp] ||
              (key === 'TeakOnSideDecks' ? ON_OFF_OPTIONS : null)

            if (key === 'BathingPlatform' && options) {
              options = options.filter(option => option.value !== 1)
            }

            if (!options || !options.length) {
              return (
                <p key={key} style={{ color: '#c00', fontSize: 13 }}>
                  {label}: missing {optionsProp}
                </p>
              )
            }

            const value = this.props.configuration[key]
            const resolvedValue =
              value && typeof value.value !== 'undefined'
                ? options.find(o => o.value === value.value) || value
                : value

            return (
              <div key={key} style={{ marginBottom: 12 }}>
                <label
                  style={{
                    display: 'block',
                    fontWeight: 600,
                    marginBottom: 4,
                    fontSize: 13
                  }}
                >
                  {label}
                </label>
                <Dropdown
                  options={options}
                  value={resolvedValue}
                  onChange={newValue => this.handleOptionChange(key, newValue)}
                  style={{ maxWidth: 472 }}
                />
              </div>
            )
          })}
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default X46MK2AllExteriorOptions



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2AllExteriorOptions.js